import { render, staticRenderFns } from "./frontLinkRedesSociales.vue?vue&type=template&id=b2883c88&scoped=true&"
import script from "./frontLinkRedesSociales.vue?vue&type=script&lang=js&"
export * from "./frontLinkRedesSociales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2883c88",
  null
  
)

export default component.exports